import { makeStyles } from 'tss-react/mui';

export default makeStyles({ name: 'ContactSalesForm' })({
    root: {
        display: 'flex',
        flexDirection: 'column',
        gap: 24
    },
    text: {
        display: 'flex',
        flexDirection: 'column',
        gap: 8
    },
    title: {
        margin: 0,
        color: '#232323',
        textAlign: 'center',
        fontSize: 24,
        fontWeight: 700,
        lineHeight: '36px',
        letterSpacing: '-0.24px'
    },
    description: {
        margin: 0,
        color: '#232323',
        textAlign: 'center',
        fontSize: 14,
        fontWeight: 500,
        lineHeight: '21px'
    },
    fields: {
        display: 'flex',
        flexDirection: 'column',
        gap: 16
    },
    button: {
        textTransform: 'capitalize',
        boxShadow: 'none !important',
        height: 56,
        padding: '20px 24px',
        color: '#FFF !important',
        fontSize: 16,
        fontWeight: 500,
        lineHeight: '100%',
        borderRadius: 16,
        background: '#232323 !important'
    }
});
